import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-datetime-modal',
  templateUrl: './datetime-modal.component.html',
  styleUrls: ['./datetime-modal.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DatetimeModalComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: DatetimeModalComponent
    }
  ]
})
export class DatetimeModalComponent implements OnInit, ControlValueAccessor, Validator {

  @Input('label') labelValue: string;
  @Input('labelClass') labelClass: string = '';
  @Input('required') required: boolean = false;

  @Input('displayFormat') displayFormat: string = environment.DATE_OUTPUT_FORMAT; // format used to display the selected date
  @Input('valueFormat') valueFormat: string = 'YYYY-MM-DD'; // format applied to the values returned by the component
  @Input('parseFormat') parseFormat: string = 'YYYY-MM-DD'; // format used to parse values passed into the component

  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();

  @Input('presentation') presentation: string = 'date'; // possible values: date, time

  @Input('hourCycle') hourCycle: string = 'h12'; // refer to https://ionicframework.com/docs/api/datetime#hour-cycle

  internalValue: string; // value provided by the internal ion-datetime this is a ISO-8601 date string
  dateObj: Date; // a javascript date object used when converting the date to other formats

  modalId: string;

  onChange = (option) => { };
  onTouched = () => { };
  disabled = false;
  touched = false;

  constructor() {
    this.modalId = Math.random().toString(36);
  }

  ngOnInit() {}

  onIonChange() {
    this.markAsTouched();
    if (this.internalValue) {
      this.dateObj = moment(this.internalValue).toDate();
      this.value = moment(this.dateObj).format(this.valueFormat);
    }
    this.valueChange.emit(this.value);
    this.onChange(this.value);
  }

  clear() {
    this.markAsTouched();
    this.internalValue = null;
    this.value = null;
    this.dateObj = null;
    this.valueChange.emit(this.value);
    this.onChange(this.value);
  }

  validate(control: AbstractControl): ValidationErrors {
    return null;
  }

  registerOnValidatorChange?(fn: () => void): void { }

  writeValue(obj: string): void {
    this.value = obj;
    if (this.value) {
      this.dateObj = moment(this.value, this.parseFormat).toDate();
      this.internalValue = moment(this.dateObj).format();
    }
    else {
      this.internalValue = null;
    }
    this.valueChange.emit(this.value);
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }
  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
    }
    this.touched = true;
  }

  applyFormat() {
    return (this.dateObj) ? moment(this.dateObj).format(this.displayFormat) : '';
  }
}
